module.exports = __webpack_public_path__ + "img/visual_no_image_schools.2e95f298.png";